import React from 'react';

function DignitasLogo() {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="107"
      height="26"
      fill="none"
      viewBox="0 0 107 26"
    >
      <g clipPath="url(#clip0_86_660)">
        <path
          fill="#EFF2F5"
          d="M99.722 23.946l-1.479-1.782c3.595-3.117 4.032-8.599.975-12.23-3.058-3.666-8.434-4.111-11.996-.994L85.745 7.16c4.536-3.94 11.39-3.358 15.254 1.267 3.864 4.625 3.293 11.58-1.276 15.52z"
        />
        <path
          fill="#FDC400"
          d="M102.794 5.24L87.303 18.66l1.5 1.802 15.493-13.42-1.502-1.802z"
        />
        <path
          fill="#EFF2F5"
          d="M.94 6.44h2.788c1.781 0 3.125.24 3.999.685.873.445 1.579 1.199 2.15 2.226.571 1.028.84 2.227.84 3.598 0 .959-.168 1.85-.47 2.672a5.23 5.23 0 01-1.31 2.021c-.572.548-1.177.925-1.815 1.13-.639.206-1.781.309-3.36.309H.939V6.439zm2.318 2.295v7.982h1.109c1.075 0 1.848-.137 2.352-.377.47-.24.873-.685 1.176-1.267.302-.583.47-1.336.47-2.193 0-1.336-.37-2.364-1.109-3.117-.672-.651-1.713-.994-3.192-.994h-.806v-.034zM13.506 6.44h2.352v12.607h-2.352V6.439zM30.508 8.495l-1.646 1.679C27.82 9.043 26.576 8.46 25.198 8.46c-1.21 0-2.251.41-3.057 1.233-.807.822-1.244 1.816-1.244 3.015 0 1.233.437 2.26 1.277 3.083.84.857 1.915 1.268 3.159 1.268.806 0 1.512-.172 2.05-.514.57-.343 1.007-.89 1.343-1.645h-3.561v-2.26h6.215l.034.547a6.24 6.24 0 01-.84 3.152c-.571.994-1.277 1.747-2.184 2.261-.907.514-1.949.788-3.125.788-1.276 0-2.419-.274-3.427-.856-1.008-.583-1.814-1.37-2.385-2.433a7.072 7.072 0 01-.874-3.391c0-1.679.538-3.118 1.613-4.351 1.277-1.473 2.957-2.193 5.006-2.193 1.075 0 2.083.206 3.024.617.773.274 1.546.856 2.285 1.713zM34.035 6.44h2.251l5.275 8.29V6.44h2.352v12.607h-2.25l-5.276-8.257v8.257h-2.352V6.439zM47.273 6.44h2.352v12.607h-2.352V6.439zM51.64 6.44h6.821v2.363h-2.25v10.244h-2.386V8.803H51.64V6.44zM63.67 6.44h2.385l4.771 12.607h-2.452l-.975-2.604h-5.04l-1.008 2.604h-2.453L63.67 6.439zm1.21 3.323l-1.647 4.316h3.292L64.88 9.763zM79.629 8.152l-1.747 1.576c-.605-.856-1.243-1.302-1.882-1.302-.302 0-.57.069-.772.24-.202.172-.303.343-.303.583 0 .205.067.41.202.616.201.24.773.788 1.713 1.61.907.754 1.445 1.234 1.647 1.44.47.479.806.959 1.008 1.404.201.445.302.925.302 1.473 0 1.028-.336 1.884-1.042 2.57-.705.685-1.612 1.027-2.755 1.027-.873 0-1.646-.205-2.318-.65-.639-.446-1.21-1.131-1.68-2.09l1.982-1.234c.605 1.13 1.277 1.679 2.05 1.679.403 0 .74-.137 1.008-.377.269-.24.403-.514.403-.822 0-.274-.1-.582-.302-.857-.202-.274-.672-.719-1.378-1.301-1.344-1.131-2.218-1.988-2.62-2.604-.404-.617-.605-1.2-.605-1.816 0-.89.335-1.61.974-2.261.638-.617 1.445-.925 2.42-.925.604 0 1.209.137 1.746.445.672.274 1.277.788 1.949 1.576z"
        />
      </g>
      <defs>
        <clipPath id="clip0_86_660">
          <path
            fill="#fff"
            d="M0 0H105.636V25.454H0z"
            transform="translate(.637 .273)"
          />
        </clipPath>
      </defs>
    </svg>
  );
}

export default DignitasLogo;
